import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './sub-header.styles';
import SubHeader from './sub-header';

export default compose(withStyles(styles))(SubHeader);
